import * as actions from "../actions/clients";

const INITIAL_STATE = {
  error: null,
  clients: null,
  savedClient: null,
  saving: false,
  client: null,
};

const clients = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case actions.RETRIEVED_CLIENTS:
      return {
        ...state,
        clients: action.clients,
      };
    case actions.SAVING_CLIENT:
      return {
        ...state,
        saving: action.saving,
      };
    case actions.SAVED_CLIENT:
      return {
        ...state,
        saving: false,
        client: action.savedClient,
      };
    case actions.CLEAR_SAVED_CLIENT:
      return {
        ...state,
        client: null,
      };
    case actions.RETRIEVED_CLIENT:
      return {
        ...state,
        client: action.client,
      };
    default:
      return state;
  }
};

export default clients;
